import ProfileOrders from './profile-orders.vue'
export default ProfileOrders